import { STORY_EPISODES, type StoryMoment } from './stories';
import type { Profile } from '../meta/profile';
import { countryOfStage, countryStages, COUNTRY_BY_ID, PROVINCE_BY_ID, conqueredCount, isCountryConquered } from '../meta/provinces';

export interface StoryCue {
  id: string; episodeId: string; moment: StoryMoment; start: number; end: number;
}
export const STORY_CUES: StoryCue[] = STORY_EPISODES.flatMap(episode => {
  const cues: StoryCue[] = [];
  episode.lines.forEach((line, index) => {
    if (!line.moment) return;
    const last = cues.at(-1);
    if (last?.moment === line.moment) last.end = index;
    else cues.push({ id: `${episode.id}:${line.moment}`, episodeId: episode.id, moment: line.moment, start: index, end: index });
  });
  return cues;
});
export const storyCue = (id: string) => STORY_CUES.find(c => c.id === id);

/** 初回の通常攻略に挟む場面。勝利後はサーバーで確定した進行を渡す。 */
export function storyCuesForBattle(profile: Profile, stageId: number, timing: 'before' | 'after'): StoryCue[] {
  const country = countryOfStage(stageId);
  if (!country) return [];
  const cleared = (id: number) => (profile.progress[String(id)]?.clears ?? 0) > 0;
  const front = PROVINCE_BY_ID[country.regions[0]], capital = PROVINCE_BY_ID[country.regions[1]];
  const episode = `main-${String(country.difficulty).padStart(2, '0')}`;
  const ids: string[] = [];
  if (timing === 'before') {
    if (cleared(stageId)) return [];
    if (stageId === 1) ids.push('main-00:intro');
    else if (country.id === 'c01' ? !countryStages(country).some(id => id !== 1 && cleared(id)) : !countryStages(country).some(cleared)) ids.push(`${episode}:enter`);
    if (stageId === capital.castle) ids.push(`${episode}:castle`);
  } else {
    if (!cleared(stageId)) return [];
    if (stageId === 1) ids.push('main-00:aftermath');
    if (stageId === front.castle && !cleared(capital.castle)) ids.push(`${episode}:fort`);
    if ((stageId === front.castle || stageId === capital.castle) && isCountryConquered(profile, country.id)) ids.push(`${episode}:clear`);
    if (conqueredCount(profile) === Object.keys(COUNTRY_BY_ID).length) ids.push('main-11:ending');
  }
  return ids.map(storyCue).filter((cue): cue is StoryCue => !!cue);
}
